import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoadingPage } from 'app/shared/components/loading/loading.page.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ScormCloudService } from 'app/core/services/scorm-cloud.service';
import { AuthService } from 'app/core/services/auth.service';
import { NotificationService } from 'app/core/services/notification.service';
import { FullscreenService } from 'app/core/services/fullscreen.service';

@Component({
  selector: 'itpx-scorm-cloud-player',
  templateUrl: './scorm-cloud-player.component.html',
  styleUrls: ['./scorm-cloud-player.component.css']
})
export class ScormCloudPlayerComponent extends LoadingPage implements OnInit, OnDestroy {
  hideFullScreen: boolean;
  private player: any;
  private deliverableId: any;
  private iframeUrl: string;
  private hideBreadCrumbBar: boolean;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private scormCloudService: ScormCloudService,
    private authService: AuthService,
    private notificationService: NotificationService,
    private fullscreenService: FullscreenService,
  ) {
    super();
    this.player = window;
  }

  ngOnInit() {
    this.fullscreenService.onFullscreen()
      .skip(1)
      .subscribe(_ => this.router.navigate(['app/dummy']));

    let routeData = this.route.params
      .take(1)
      .map(params => ({ deliverableId: params['deliverableId'], registrationId: params['registrationId'] }))
      .cacheResult();

    routeData
      .subscribe(data => this.deliverableId = data);

    // Initially start the scorm player
    routeData
      .flatMap(data => this.scormCloudService.getRegistrations(data.registrationId, window.location.origin))
      .bindToLifecycle(this)
      .map(body => body.data)
      .subscribe(
      data => {
        this.ready();
        this.iframeUrl = data.launchUrl;
      },
      err => this.handleError(err)
      );

    this.fullscreenService.onFullscreen().subscribe(val =>
      this.hideBreadCrumbBar = val
    )
  }

  private handleError(error: any) {
    this.notificationService.error(error, 'Failed');
    this.hideFullScreen = true;
    this.ready();
  }

  onFullScreen() {
    let mainContainer = document.getElementById('main-c');
    this.fullscreenService.enterFullscreen(mainContainer);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/scorm-cloud-player/scorm-cloud-player.component.ts